import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// eslint-disable-next-line security/detect-unsafe-regex -- each repetition consumes exactly one digit, so matching is linear
export const PHONE_PATTERN = /^\+?([()./ -]{0,2}\d){7,15}$/;

export const createPhoneValidator = (): ValidatorFn => {
  return (control: AbstractControl): Nullable<ValidationErrors> => {
    const value = control.value;

    if (!value) {
      return null;
    }

    return PHONE_PATTERN.test(value.trim()) ? null : { phoneInvalid: true };
  };
};
